import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { ActionButtonGenericComponent, VALIDATION } from '../action-button-generic/action-button-generic.component';

@Component({
    selector: 'app-temp-form',
    templateUrl: './temp-form.component.html',
    styleUrls: ['./temp-form.component.scss'],
    standalone: false
})
export class TempFormComponent implements OnInit {

  constructor(private dialog:DialogService, private fb:UntypedFormBuilder,
    @Inject(VALIDATION) public validation:BehaviorSubject<String>) { }

  ngOnInit(): void {
  }


  click(){
      this.validation.next(JSON.stringify({		"type":"action",    
      "actionIcon":"search",    
      "component":"ActionButtonGenericComponent",    
      "toolTip":"Selecionar Marca",
      "returnType":"array",
      "arrayPath":"$.response.brand_list",
      "title":"Busca de Marcas",
      "widthPopUp":"50vw",
      "colsCount":5,
      "showSearch":true,
      "showButton":true,
      "buttonList":[{
        "description":"Próxima Página",
        "color":"primary",
        "action":"(scope,objectUtil):void=>{  scope.spinner.show('generic-action'); let arrayData:Object[] = []; let group:FormGroup = scope.data as FormGroup; Object.keys(group.controls).forEach(control=>{ const abstractControl = group.controls[control]; if ( abstractControl.value != null){ arrayData.push({ 'key':'@'+control, 'value':abstractControl.value instanceof Object ? abstractControl.value['id'] == null ? '' : abstractControl.value['id'] : abstractControl.value }) } }); let newExpression= 'getRequestData(GetBrandList,Product,?getFullShopeeParams({@CODECOMPANY},/api/v2/product/get_brand_list)&language=pt-br&category_id={@CATEGORY_ID}&offset=@offset&page_size=100&status=1,GET,null,null,{@CODEMKTP})'; newExpression = newExpression.replace('@offset',objectUtil.FindObject(scope.dataResponse,'$.response.next_offset'));  let ob = { \"expressao\": newExpression, \"novo\": true, \"codecompany\": scope.codecompany, \"codemktp\": scope.codemktp != null ? scope.codemktp : 0, \"codecontract\": scope.codecontract, \"values\":arrayData }; scope.http.post(ob,'FormulaServices\/test', true,true,false).subscribe(data=>{ let resultado = data['resultado']; if ( resultado ){scope.scrollToBottom(); scope.dataResponse = JSON.parse(resultado);  let newArray = objectUtil.FindObject(scope.dataResponse,scope.arrayPath)[0]; for ( var line of newArray) { scope.tempArray.push(line); }} scope.spinner.hide('generic-action'); },error=>{ scope.spinner.hide('generic-action'); throw error; },()=>{ scope.spinner.hide('generic-action'); })  }"
      }],
      "cols":[
        {
          "colspan":"2",
          "type":"text",
          "path":"$.brand_id",
          "name":"Id. Marca"
        },
        {
          "colspan":"3",
          "type":"text",
          "path":"$.display_brand_name",	
          "name":"Nome da Logísica"
        }
      ],
      "actionButtonDataPath":"$.brand_id",
      "formulaExpression":"getRequestData(GetBrandList,Product,?getFullShopeeParams({@CODECOMPANY},/api/v2/product/get_brand_list)&language=pt-br&category_id={@CATEGORY_ID}&offset=0&page_size=100&status=1,GET,null,null,{@CODEMKTP})",
      "codemktp":47
  }));

      let data = this.fb.group({
          CODECOMPANY: 122,
          CODEPRODUCT: 19792,
          CODECONTRACT: 1,
          CODESHOPEE: 1,
          CATEGORY_ID: 101226
      })
      this.dialog.openGenericDialog(ActionButtonGenericComponent,data,(t)=>{

      })
      
  }

}
